const ROLE_MAP = {
  employee: 'employee',
  manager: 'company_admin',
  admin: 'super_admin',
  company_admin: 'company_admin',
  super_admin: 'super_admin'
};

export const normalizeRole = (role) => ROLE_MAP[role] || 'employee';

export const hasAnyRole = (role, allowedRoles = []) => {
  const normalizedRole = normalizeRole(role);
  return allowedRoles.includes(normalizedRole);
};
